import { render, staticRenderFns } from "./MonthlyPayslips.vue?vue&type=template&id=3c2f1ba8&scoped=true"
import script from "./MonthlyPayslips.vue?vue&type=script&lang=js"
export * from "./MonthlyPayslips.vue?vue&type=script&lang=js"
import style0 from "./MonthlyPayslips.vue?vue&type=style&index=0&id=3c2f1ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f1ba8",
  null
  
)

/* custom blocks */
import block0 from "./MonthlyPayslips.vue?vue&type=custom&index=0&blockType=upload-image"
if (typeof block0 === 'function') block0(component)

export default component.exports